import { Component, Input } from '@angular/core';
import { DisplayError } from '../../../../services/error.service';

@Component({
  selector: 'error-section',
  templateUrl: 'error-section.component.html',
})
export class ErrorSectionComponent {
  showPasscodeValidationError: boolean;
  private _errors: DisplayError[];

  @Input()
  set errors(err: DisplayError[]) {
    if (!err) {
      return;
    }
    const incorrectPasscodeMessage = err.find(
      (e) => e.data === 'Incorrect passcode, please try again'
    );
    if (incorrectPasscodeMessage) {
      this._errors = err.filter((e) => e != incorrectPasscodeMessage);
      this.showPasscodeValidationError = true;
    } else {
      this._errors = err;
      this.showPasscodeValidationError = false;
    }
  }

  get errors(): DisplayError[] {
    return this._errors;
  }
}
